import React, { PureComponent } from 'react';

import { Table, Checkbox, TableRow, TableBody, TableHead } from '@mui/material';

import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';

import Cell from '../../../common/Cell';
import Node from '../../../common/Node';

import InfiniteScroll from 'react-infinite-scroll-component';
import Loader from '../../../common/Loader';

export default class SendFormContactsList extends PureComponent {
  state = {
    items: 100,
  };

  fetchMoreData = () => {
    this.setState({ items: this.state.items + 100 });
  };

  getContactsChunk = () => {
    const { items } = this.state;
    const { contacts } = this.props;

    return contacts.slice(0, items);
  }

  render() {
    const {
      items
    } = this.state;

    const {
      classes,
      isAllContactsChecked,
      subValue,
      contacts,
      onSelectAllContactsChange,
      onContactCheckBoxChange,
    } = this.props;

    const contactsChunk = this.getContactsChunk();
    const hasMoreData = contactsChunk.length < contacts.length;

    return (
      <InfiniteScroll
        dataLength={items}
        next={this.fetchMoreData}
        hasMore={hasMoreData}
        loader={
          hasMoreData &&
          <div style={{ display: 'flex', justifyContent: 'center', margin: '15px 0' }}>
            <Loader />
          </div>
        }
        style={{overflow: 'hidden'}}
      >
        <Table>
          <TableHead>
            <TableRow>
              <Cell>
                <Checkbox color="primary" checked={isAllContactsChecked} onChange={(e) => onSelectAllContactsChange(e)} />
              </Cell>
              <Cell>#</Cell>
              <Cell>Name</Cell>
              <Cell>Email</Cell>
              <Cell>Phone</Cell>
              <Cell>Facebook MID</Cell>
              <Cell>Telegram ID</Cell>
              <Cell>Status</Cell>
            </TableRow>
          </TableHead>

          <TableBody>
            {contactsChunk.map((contact, index) => {
              if (subValue !== 'contact' && !contact.ancestors.includes(+subValue)) {
                return null;
              }

              const tableContactEmail =
                contact.contact_info && contact.contact_info.EMAIL ? contact.contact_info.EMAIL : '';

              const tableContactPhone =
                contact.contact_info && contact.contact_info.PHONE ? contact.contact_info.PHONE : '';

              const tableContactFb =
                contact.contact_info && contact.contact_info.FACEBOOK_MID ? contact.contact_info.FACEBOOK_MID : '';

              const tableContactTg =
                contact.contact_info && contact.contact_info.FACEBOOK_MID ? contact.contact_info.TELEGRAM_ID : '';

              const node = {
                title: contact.contact_info && contact.contact_info.title,
                id: contact.contact_info && contact.contact_info.contact_id,
                color: contact.color ? contact.color : 'dbdbdb',
              };

              return (
                <TableRow className={contact.isDisabled ? classes.contactDisabled : ''} key={index}>
                  <Cell>
                    <Checkbox
                      color="primary"
                      checked={contacts[index].isNeedToSend}
                      onChange={(e) => onContactCheckBoxChange(index, e)}
                    />
                  </Cell>

                  <Cell>{index + 1}</Cell>

                  <Cell className={classes.tableContact}>
                    {!contact.contact_info.no_auth ? (
                      <Node
                        isLink
                        size="md"
                        node={node}
                        nodeId={contact.contact_info.contact_id}
                        style={{
                          zoom: '0.8',
                        }}
                      />
                    ) : null}
                  </Cell>

                  <Cell className={classes.tableContact}>{tableContactEmail}</Cell>

                  <Cell className={classes.tableContact}>{tableContactPhone}</Cell>

                  <Cell className={classes.tableContact}>{tableContactFb}</Cell>

                  <Cell className={classes.tableContact}>{tableContactTg}</Cell>

                  <Cell className={classes.tableStatus}>
                    {contact.isSended ? (
                      <CheckCircleOutline
                        style={{
                          color: '#37ff00',
                        }}
                      />
                    ) : !contact.isSended && contact.error ? (
                      <span className={classes.contactErrorText}>{contact.error}</span>
                    ) : null}
                  </Cell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </InfiniteScroll>
    );
  }
}
